export class UserFeaturesState {
    constructor() {
        /** Names of the group-controlled features (server Feature enum names) this user can use. */
        this.features = [];
    }
    canUse(featureName) {
        return this.features.includes(featureName);
    }
}
